import { Component, OnInit, HostListener } from '@angular/core';
import { AuthService } from 'src/shared/services/REST-API/rest.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.css']
})
export class EventListComponent implements OnInit {
  slideGridNumber = 0;
  eventList;
  lenghtOfEventList;
  screenWidth;

  constructor(private authApi: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show();
    this.screenWidth = window.innerWidth;
    this.authApi.eventList().subscribe((data) => {
      this.eventList = data;
      this.lenghtOfEventList = this.eventList.length;
      this.spinner.hide();
    })
  }

  getImagePath(i) {
    i = i % 4;
    return "../../assets/images/event-" + i + ".webp"
  }

  showCard(i) {
    if (this.screenWidth > 425) {
      if (Math.floor(i / 3) == this.slideGridNumber) {
        return { 'toShow': false }
      } else {
        return { 'toShow': true }
      }

    } else {
      if (i == this.slideGridNumber) {
        return { 'toShow': false }
      } else {
        return { 'toShow': true }
      }
    }

  }
  scrollRight() {
    --this.slideGridNumber;
  }
  scrollLeft() {
    ++this.slideGridNumber;
  }
  showRightArrow() {
    if (this.screenWidth < 425) {
      if (this.slideGridNumber == this.lenghtOfEventList - 1) {
        return false
      } else {
        return true
      }
    } else {
      if (this.slideGridNumber == Math.ceil(this.lenghtOfEventList / 3) - 1) {
        return false
      } else {
        return true
      }
    }
  }

  onClickEventCard(eventDetails) {
    this.router.navigate(['/events'], { queryParams: { event_id: eventDetails._id } })
    localStorage.setItem('eventDeatils', JSON.stringify(eventDetails))
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = window.innerWidth;
  }

}
